/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import ContentBox from "../ContentBox/ContentBox";
import ButtonLoading from "../Button/ButtonLoading";
import LegalbirdDropzone from "../Case/CaseUploadFile/LegalbirdDropzone";
import ApiClient from "../../services/ApiClient";
import { enqueueSnackbar } from "notistack";

export default function ScanDocument() {
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState<Array<File>>([]);
  const [updateKey, setUpdateKey] = useState(0);

  if (import.meta.env.VITE_DEPLOYMENT === "production") {
    return null;
  }

  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      const formData = new FormData();
      if (files[0]) formData.append("file", files[0]);

      await ApiClient.post("/lb/scan_document", {
        body: formData,
      });

      setFiles([]);
      setUpdateKey((prevKey) => prevKey + 1);

      enqueueSnackbar("Dokument wurde eingescannt.", {
        variant: "custom",
        buttonType: "link",
        buttonLink: "/services/tools/dokumente-pruefen",
        buttonTarget: "_self",
        buttonText: "Zum Posteingang",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        autoHideDuration: 10000,
      });
    } catch (error) {
      enqueueSnackbar("Dokument konnte nicht gescannt werden!", {
        variant: "custom",
        isNonInteractive: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <ContentBox>
      <Grid container spacing={1} sx={{
        alignItems: "center"
      }}>
        <Grid size={12}>
          <Typography>
            Hier können Dokumente hochgeladen werden, als ob sie über den Scanprozess ins System gelangen würden. Die
            Dokumente durchlaufen den Scanprozess und können dann im Posteingang weiter verarbeitet werden.
            <br />
            <strong>Wichtig:</strong> der Scanprozess läuft derzeit asynchron, die Dokumente erscheinen aber immer schon
            direkt im Posteingang. Daher immer erst kurz abwarten und den Posteingang zur Sicherheit nach kurzer
            Wartezeit neu laden, um das finale Ergebnis zu erhalten.
          </Typography>
        </Grid>
        <Grid size={12}>
          <LegalbirdDropzone files={files} setFiles={setFiles} key={updateKey} />
        </Grid>
        <Grid
          sx={{
            py: 3
          }}
          size={12}>
          <ButtonLoading
            variant={"contained"}
            onClick={handleSubmit}
            isLoading={isLoading}
            disabled={files.length === 0}
          >
            Dokument scannen
          </ButtonLoading>
        </Grid>
      </Grid>
    </ContentBox>
  );
}
